import { TStatusConf } from '../status-header.component';

const MM_MOBILE = {
  active: {
    color: '#fff',
    backgroundColor: '#0028b8',
    border: '1px solid #0028b8',
    'text-align': 'center',
    padding: '12px',
  },
  default: {
    color: '#282c3f',
    backgroundColor: '#fff',
    border: 'solid 1px rgba(40, 44, 63, 0.2)',
    'text-align': 'center',
    padding: '12px',
  },
  colSize: 6,
};

const MM_WEB = {
  active: {
    color: '#0033EB',
    backgroundColor: '#C4D0FA',
    border: '4px solid #C4D0FA',
    'border-bottom': '4px solid #0033EB',
  },
  default: {
    color: '#0033EB',
    backgroundColor: '#f8f8f8',
    border: '4px solid #f8f8f8',
  },
};

export const MACHINE_ISSUE_STATUS_CONF: TStatusConf = [
  {
    status: 'REPORTED',
    displayName: 'tm_common.Reported',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'IN_REPAIR',
    displayName: 'tm_common.In-Repair',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'PENDING_APPROVAL',
    displayName: 'tm_common.Pending',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'APPROVED',
    displayName: 'tm_common.Repaired',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const MAINTENANCE_TICKETS_STATUS_CONF: TStatusConf = [
  {
    status: 'MAINTENANCE_PENDING',
    displayName: 'tm_common.Upcoming',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'IN_MAINTENANCE',
    displayName: 'tm_common.In-Progress',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'MAINTENANCE_COMPLETED',
    displayName: 'tm_common.Completed',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'MAINTENANCE_OVERDUE',
    displayName: 'tm_common.Overdue',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const LINE_SETUP_TICKETS_STATUS_CONF: TStatusConf = [
  {
    status: 'UPCOMING',
    displayName: 'tm_common.Created',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'IN_PROGRESS',
    displayName: 'tm_common.In-Progress',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'OVERDUE',
    displayName: 'tm_common.Overdue',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'COMPLETED',
    displayName: 'tm_common.Completed',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const LINE_SETUP_TICKETS_SCREEN_CONF: TStatusConf = [
  {
    status: 'TICKETS',
    displayName: 'tm_common.Tickets',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'LINES',
    displayName: 'tm_common.Lines',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const QCO_TICKET_DETAILS_HEADER_CONF: TStatusConf = [
  {
    status: 'CURRENT_SETUP',
    displayName: 'tm_common.CurrentSetup',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'NEW_SETUP',
    displayName: 'tm_common.NewSetup',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const MACHINE_HISTORY_STATUS_CONF: TStatusConf = [
  {
    status: 'MACHINE_ISSUE_TICKETS',
    displayName: 'Machine Issue Tickets',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'MAINTENANCE_TICKETS',
    displayName: 'Maintenance Tickets',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const NEEDLE_REQUEST_STATUS_CONF: TStatusConf = [
  {
    status: 'PENDING',
    displayName: 'sp_needle_request.PendingRequests',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'APPROVED',
    displayName: 'sp_needle_request.ApprovedRequests',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'REJECTED',
    displayName: 'sp_needle_request.RejectedRequests',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
  {
    status: 'CANCELLED',
    displayName: 'sp_needle_request.CancelledRequests',
    mobile: MM_MOBILE,
    web: MM_WEB,
  },
];

export const LOCAL_NEEDLE_REQUEST_STATUS_CONF: TStatusConf = [
  {
    status: 'PENDING',
    displayName: 'sp_needle_request.PendingRequests',
    mobile: { ...MM_MOBILE, colSize: 4 },
    web: MM_WEB,
  },
  {
    status: 'APPROVED',
    displayName: 'sp_needle_request.ApprovedRequests',
    mobile: { ...MM_MOBILE, colSize: 4 },
    web: MM_WEB,
  },
  {
    status: 'REJECTED',
    displayName: 'sp_needle_request.RejectedRequests',
    mobile: { ...MM_MOBILE, colSize: 4 },
    web: MM_WEB,
  },
];

export const ATTACHMENT_APPROVAL_HEADER_CONF: TStatusConf = [
  {
    status: 'IN_REPAIR',
    displayName: 'attachment.Created',
    mobile: { ...MM_MOBILE, colSize: 6 },
    web: MM_WEB,
  },
  // [NOTE]: We don't show approved bucket right now, however it's implemented on frontend, so whenever backend adds support for it, we can start showing it on ui as well.
  // {
  //   status: 'REPAIR_APPROVED',
  //   displayName: 'attachment.Approved',
  //   mobile: { ...MM_MOBILE, colSize: 4 },
  //   web: MM_WEB,
  // },
  {
    status: 'REPAIR_REJECTED',
    displayName: 'attachment.Rejected',
    mobile: { ...MM_MOBILE, colSize: 6 },
    web: MM_WEB,
  },
];

export const MULTIPLE_SHIFT_MANAGEMENT_HEADER_CONF: TStatusConf = [
  {
    status: 'SHIFT',
    displayName: 'shift_management.Shifts',
    mobile: { ...MM_MOBILE, colSize: 4 },
    web: MM_WEB,
  },
  {
    status: 'LINES',
    displayName: 'shift_management.Lines',
    mobile: { ...MM_MOBILE, colSize: 4 },
    web: MM_WEB,
  },
];
